// E7 caps `limit` at 100 and returns no total, so a full page is the only sign of a next one.
export const FINANCING_ENDING_OPERATION_ITEMS_PAGE_SIZE = 100;
